import { useState, useEffect } from 'react';
import { get } from 'lodash';
import { coreApi } from 'src/api/config';

const useAssistanceRequest = (assistanceRequestId) => {
  const [assistanceRequest, setAssistanceRequest] = useState(null);

  useEffect(() => {
    const fetchAssistanceRequest = async () => {
      if (assistanceRequestId) {
        try {
          const assistanceRequestsQuery = await coreApi.query('assistance_requests', {
            id: assistanceRequestId,
          });
          const assistanceRequestData = get(assistanceRequestsQuery, 'data.data', []);
          await Promise.all([
            coreApi.populateRelationship('provider', 'provider', assistanceRequestData),
            coreApi.populateRelationship('case', 'case', assistanceRequestData),
          ]);
          setAssistanceRequest(assistanceRequestData[0]);
        } catch (error) {
          setAssistanceRequest(null);
        }
      }
    };
    fetchAssistanceRequest();
  }, [assistanceRequestId]);

  return assistanceRequest;
};

export default useAssistanceRequest;
